import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, isRef as _isRef } from "vue";
import { computed, ref } from "vue";
export default {
  __name: 'Tm-dialog',
  props: {
    isFooter: {
      type: Boolean,
      default: true
    },
    ConfirmLoading: {
      type: Boolean,
      default: false
    },
    showBtnLoading: {
      type: Boolean,
      default: false
    },
    //控制 dialog 显示
    isShow: {
      type: Boolean,
      default: undefined
    },
    //标题颜色
    titleColor: {
      type: String,
      default: null
    },
    //标题宽度
    width: {
      type: [Number, String],
      default: null
    },
    //标题内容
    title: {
      type: String,
      default: "弹出框标题"
    },
    click_modal: {
      type: Boolean,
      default: true
    },
    press_escape: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: true
    },
    overflow: {
      type: Boolean,
      default: false
    },
    //提示栏字体颜色
    tipColor: {
      type: String,
      default: "#3480FB"
    },
    //提示栏内容
    tipContent: {
      type: String,
      default: "温馨提示"
    },
    //底部按钮对齐方式
    footerAlign: {
      type: String,
      default: "center"
    },
    //是否显示提醒行
    tip: Boolean,
    //是否展示取消按钮
    showCancelButton: {
      type: Boolean,
      default: true
    },
    //是否展示确认按钮
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    // 是否禁止确认按钮
    sureButton1: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:isShow", "closeDialog", "handleConfirm", "close", "confirm", "open", "opend"],
  setup(__props, {
    emit: __emit
  }) {
    const isShow = ref(false);
    const props = __props;
    const emit = __emit;
    // 计算属性 计算展示与否的属性
    let getShow = computed({
      get: () => props.isShow,
      set: val => {
        emit("update:isShow", val);
      }
    });
    // 取消按钮事件
    const handleClose = () => {
      console.log("弹框关闭");
      emit("closeDialog");
      emit("close");
      // getShow = false;
    };
    // 确定按钮事件
    const handleConfirm = () => {
      emit("handleConfirm");
      emit("confirm");
      // getShow = false;
    };

    const handleDialogOpen = () => {
      emit("open");
      console.log("弹框开始");
    };
    const handleDialogOpend = () => {
      emit("opend");
      console.log("弹窗渲染完毕");
    };

    //  一般用不到
    // const tipBackground = computed(() => {
    //   let tipBackground = "";
    //   tipBackground = props.tipColor + "14";
    //   return tipBackground;
    // });

    return (_ctx, _cache) => {
      const _component_WarningFilled = _resolveComponent("WarningFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(getShow),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(getShow) ? getShow.value = $event : getShow = $event),
        title: __props.title,
        modal: __props.modal,
        "close-on-click-modal": __props.click_modal,
        "close-on-press-escape": __props.press_escape,
        width: __props.width,
        onOpened: handleDialogOpend,
        onOpen: handleDialogOpen,
        onClose: handleClose,
        draggable: "",
        overflow: __props.overflow
      }, {
        footer: _withCtx(() => [__props.isFooter ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "dialog-footer",
          style: _normalizeStyle({
            textAlign: __props.footerAlign
          })
        }, [_renderSlot(_ctx.$slots, "button"), __props.showCancelButton ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          disabled: __props.sureButton1,
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), __props.showConfirmButton ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          loading: __props.showBtnLoading,
          disabled: __props.sureButton1,
          type: "primary",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        }, 8, ["loading", "disabled"])) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true)]),
        default: _withCtx(() => [__props.tip ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex-tip",
          style: _normalizeStyle({
            color: __props.tipColor,
            background: _ctx.tipBackground
          })
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(__props.tipContent), 1)], 4)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "dialogBody")]),
        _: 3
      }, 8, ["modelValue", "title", "modal", "close-on-click-modal", "close-on-press-escape", "width", "overflow"])]);
    };
  }
};